export default __webpack_public_path__ + "static/media/ReportIcon-Foot-MS.6491b8e6.jpg";